import { render, staticRenderFns } from "./subLibraryDetails.vue?vue&type=template&id=50eb9fd3&scoped=true"
import script from "./subLibraryDetails.vue?vue&type=script&lang=js"
export * from "./subLibraryDetails.vue?vue&type=script&lang=js"
import style0 from "./subLibraryDetails.vue?vue&type=style&index=0&id=50eb9fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb9fd3",
  null
  
)

export default component.exports